// extracted by mini-css-extract-plugin
var _1 = "bnmRhibeZcHj1pWrptr3";
var _2 = "z7HTWCHkrYRkopPy8vAX";
export { _1 as "logo", _2 as "menu-scroll-container" }
